import { createSelector } from 'reselect';
import { AGENT_PRESENCE } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const hasAgentPresenceAccess = createSelector([getScopes], scopes => scopes.includes(AGENT_PRESENCE));